import type { ConnectionPositionPair } from '@angular/cdk/overlay';
import { NgOptimizedImage } from '@angular/common';
import { Component, inject, signal } from '@angular/core';

import { QrCodeModule } from 'ng-qrcode';

import { injectTranslate, TranslatePipe } from '@core/i18n-legacy';
import { UserInvitationFacade } from '@core/tellent-user-invitation-logic';
import { UserInvitationData } from '@core/tellent-user-invitation-types';
import {
  ButtonComponent,
  ClipboardCopy,
  ConnectedOverlayDirective,
  DialogBodyComponent,
  DialogComponent,
  DialogFooterComponent,
  DialogHeaderComponent,
  DropdownComponent,
  DropdownWidth,
  IconComponent,
  OverlayOriginDirective,
} from '@core/user-interface-legacy';

@Component({
  selector: 'tla-subdomain-information-dialog',
  templateUrl: './subdomain-information-dialog.component.html',
  styleUrls: ['./subdomain-information-dialog.component.less'],
  imports: [
    DialogBodyComponent,
    DialogFooterComponent,
    DialogHeaderComponent,
    ButtonComponent,
    TranslatePipe,
    IconComponent,
    NgOptimizedImage,
    OverlayOriginDirective,
    ConnectedOverlayDirective,
    DropdownComponent,
    QrCodeModule,
  ],
})
export class SubdomainInformationDialogComponent extends DialogComponent<
  UserInvitationData,
  UserInvitationData
> {
  private readonly userInvitationFacade = inject(UserInvitationFacade);
  private readonly clipboard = inject(ClipboardCopy);
  private readonly t = injectTranslate();

  public readonly DropdownWidth = DropdownWidth;
  public readonly dropdownPositions: ConnectionPositionPair[] = [
    { originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top' },
    { originX: 'start', originY: 'top', overlayX: 'end', overlayY: 'top' },
  ];

  public qrCodeDropdownOpen = signal<boolean>(false);
  public loginPageUrl = this.userInvitationFacade.companyLoginPage;

  public copyLink(): void {
    this.clipboard.fromString(
      this.loginPageUrl()!,
      this.t('tlc.members.subdomain_information_dialog.copied'),
    );
  }

  public gotIt(): void {
    this.dialogRef.close({});
  }

  public generateFileAgain(): void {
    this.userInvitationFacade.downloadPasswords(this.dialogData.payload!);
  }
}
